module.exports = __webpack_public_path__ + "static/media/AVElogo.3ebf27fe.svg";